// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"6f6dfb28","289":"61455132","695":"8fc45d4f","787":"2fe65118","815":"c6adf81c"}[chunkId] + ".chunk.js";
};